import { themeOptions } from '@/core/theme';
import { SimplePaletteColorOptions } from '@mui/material';
import { styled } from '@mui/system';

const warningColors = themeOptions.palette?.warning as SimplePaletteColorOptions;
const successColors = themeOptions.palette?.success as SimplePaletteColorOptions;
const VariantToColorMap = {
  error: themeOptions.palette?.common?.black,
  warning: warningColors?.main,
  success: successColors?.main,
} as const;

export const HBToastStyled = styled('div', {
  shouldForwardProp: (prop) => prop !== 'variant',
})<{
  variant: keyof typeof VariantToColorMap;
}>(({ theme, variant }) => {
  return {
    color: 'white',
    '& .hb-snackbar': {
      backgroundColor: VariantToColorMap[variant],
      color: 'white',
      display: 'flex',
      alignItems: 'center',
      borderRadius: theme.shape.borderRadius * 2,
      padding: theme.spacing(2, 4),
      '& .uil': {
        marginLeft: theme.spacing(1),
        display: 'flex',
        alignItems: 'center',
      },
    },
  };
});
